import { defineStore } from 'pinia';
import { masterDataApiService } from 'src/services';
export const useMasterDataDropdownStore = defineStore('master_data_dropdown', {
  state: () => ({
    master_data_types: [] as any,
    master_data_types_fields: [] as any,
  }),
  actions: {
    setMasterDataTypesList(response: any) {
      if (!Array.isArray(response) || response.length == 0) {
        return;
      }

      response.forEach((item: string, index: number) => {
        this.master_data_types.push(
          Object.assign({}, { value: item, label: item }),
        );
      });
    },

    async getMasterDataTypesAndFields() {
      this.master_data_types = [];
      const response = await masterDataApiService.getTypes();
      if (!response) {
        return;
      }

      this.setMasterDataTypesList(response);
      if (!Array.isArray(response) || response.length == 0) {
        return;
      }
      response.forEach((item: string, index: number) => {
        this.getMasterDataFields(item);
      });
    },

    async getMasterDataFields(type_name: string) {
      const response = await masterDataApiService.getTypeFields(type_name);
      if (!response) {
        return;
      }

      if (!Array.isArray(response) || response.length == 0) {
        return;
      }
      response.forEach((item: string, index: number) => {
        const ms_field_name = item.toLowerCase();
        this.master_data_types_fields.push(
          Object.assign(
            {},
            { value: ms_field_name, label: item, type: type_name },
          ),
        );
      });
    },
  },
});
